<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-row>
      <v-col cols="12" class="mt-4">
        <v-text-field
          v-model="model.itemName"
          :counter="128"
          :rules="[vr.primitives.required, vr.primitives.maxLength(128)]"
          :label="$t('Name')"
          class="px-1"
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-select
          :items="availableCurrencies"
          item-text="description"
          item-value="code"
          v-model="model.currency"
          required
          :label="$t('Currency')"
           class="px-1"
          outlined
        ></v-select>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model.lazy="model.price"
          :label="$t('Price')"
          :rules="[vr.primitives.biggerThan(0), vr.primitives.precision(2)]"
          required
          class="px-1"
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="model.externalReference"
          :counter="50"
          :rules="[vr.primitives.maxLength(50)]"
          :label="$t('ExternalReference')"
          class="px-1"
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6" class="py-0">
        <v-text-field
          v-model="model.woocommerceID"
          :counter="50"
          :rules="[vr.primitives.maxLength(50)]"
          :label="$t('WoocommerceID')"
          class="px-1"
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" class="d-flex justify-end" v-if="!$vuetify.breakpoint.smAndDown">
        <v-btn class="mx-2" color="white" :to="cancelRoute" @click="$emit('cancel')">
          {{$t('Cancel')}}</v-btn>
        <v-btn color="primary" class="mx-2" @click="ok()">{{$t('Save')}}</v-btn>
      </v-col>
      <v-col cols="12" v-if="$vuetify.breakpoint.smAndDown">
        <v-btn block color="white" :to="cancelRoute" @click="$emit('cancel')">
        {{$t('Cancel')}}</v-btn>
        <v-spacer class="py-2"></v-spacer>
        <v-btn block color="primary" @click="ok()">{{$t('Save')}}</v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapState } from "vuex";
import ValidationRules from "../../helpers/validation-rules";

export default {
  props: {
    data: {
      type: Object,
      default: null,
      required: true
    },
    cancelRoute: {
      type: String,
      default: '/items/list',
    }
  },
  data() {
    return {
      model: { ...this.data },
      vr: ValidationRules,
      dictionaries: {},
      valid: true
    };
  },
  computed: {
    ...mapState({
      systemCurrency: state => state.settings.currency,
      availableCurrencies: state => state.settings.availableCurrencies,
      terminalStore: state => state.settings.terminal
    }),
  },
  async mounted(){
    if(!this.model.currency){
      this.model.currency = this.systemCurrency.code;
    }
    if (this.terminalStore.settings.vatExempt) {
      this.model.withoutVat = true;
    }
  },
  methods: {
    ok() {
      if (!this.$refs.form.validate()) return;
      this.$emit('ok', this.model);
    }
  },
};
</script>

<style lang="scss" scoped>
</style>